import { styled } from "@/components";

const CustomBox = styled("div")(() => ({}));

export { CustomBox };
